import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { useContext,useEffect } from 'react';
import { WebFormContext } from '../../context/WebFormContext';
import { ItemFormFilling } from '../../types/new-form-filling/types';
import { CheckIconItem } from './CheckIcon';


export default function CheckIconItemComp({ item }: { item: ItemFormFilling }) {
  const { changeValue, webForm } = useContext(WebFormContext);

  useEffect(() => {
  }, [changeValue, webForm]);

  const checkValues = () => {
    switch (CheckIconItem(item)) {
      case 'ok':
        return (<TaskAltIcon color='success' />);
      case 'naoOk':
        return (<PriorityHighIcon color='warning' />);
      default: return (<></>);
    }
  };


  return (
    <>
      {checkValues()}
    </>
  );
}